<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card :title="`${id ? '编辑' : '添加'}商品`">

                <a-form :form="form" style="width: 900px">
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span>选择店铺:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择店铺"
                            v-decorator="[`shop_id`, { rules: [{ required: true, message: '请选择店铺' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in Shoplist" :key="key">{{
                                value.name
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 分类:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择分类"
                            v-decorator="[`cat_id`, { rules: [{ required: true, message: '请选择分类' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in fenlei" :key="key">
                                {{ value.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 首页分类:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择分类"
                            v-decorator="[`goods_cat_id`, { rules: [{ required: true, message: '请选择分类' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in goodscatlist" :key="key">{{
                                value.name
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red"></span> 活动专区:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择活动专区"
                            v-decorator="[`goods_cats_id`, { rules: [{ required: false, message: '请选择活动专区' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in goodscatslist" :key="key">{{
                                value.name
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 成新度:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择成新度"
                            v-decorator="[`newness_id`, { rules: [{ required: true, message: '请选择成新度' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in newnesslist" :key="key">{{
                                value.title
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 邮费模版:</span>
                        <a-select allowClear style="width:100%" mode="multiple" placeholder="请选择邮费模版"
                            v-decorator="[`discounts_id`, { rules: [{ required: true, message: '请选择邮费模版' }] }]">
                            <a-select-option :value="value.id.toString()" v-for="(value, key) in discountslist"
                                :key="key">{{
                                    value.title
                                }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span>是否选为热销:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择热销"
                            v-decorator="[`hot`, { rules: [{ required: true, message: '请选择热销' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in hotlist" :key="key">{{
                                value.title
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span>上下架:</span>
                        <a-select allowClear style="width:100%" placeholder="请选择上下架"
                            v-decorator="[`putaway`, { rules: [{ required: true, message: '请选择上下架' }] }]">
                            <a-select-option :value="value.id" v-for="(value, key) in putawaylist" :key="key">{{
                                value.title
                            }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 商品名称:</span>
                        <a-input v-decorator="[`name`, { rules: [{ required: true, message: '请输入商品名称' }] }]"
                                 placeholder="请输入商品名称" />
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> 商品详情:</span>
                        <a-input v-model="shopDetail" placeholder="请输入商品详情" />
                    </a-form-item>

                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span>是否启用外链跳转:</span>
                        <a-radio-group  allowClear style="width:100%" v-model="is_open_url" >
                             <a-radio :value="1">否</a-radio>
                             <a-radio :value="2">是</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> 跳转外链:</span>
                        <a-textarea v-model="url" placeholder="请输入支付宝跳转url"  />
                    </a-form-item>

                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 图片:</span>
                        <a-row :gutter="10" class="inputGroup" style="margin-bottom: 20px" type="flex"
                            justify="space-around" align="middle">
                            <a-col :xs="12" :md="8" :lg="8" :xl="10">
                                <div class="imgContaienr">
                                    <div class="con">
                                        <img v-if="img !== ``" :src="img" />
                                        <a v-else class="placeText">请选择图片</a>
                                    </div>
                                </div>
                            </a-col>
                            <a-col :xs="24" :md="8" :lg="8" :xl="14">
                                <div class="btnCon">
                                    <input @change="handleChange($event, 2)" type="file" accept="image/*" />
                                    <a-button-group>
                                        <a-button type="primary">选择图片</a-button>
                                    </a-button-group>
                                </div>
                            </a-col>
                        </a-row>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 轮播图:</span>
                        <div class="clearfix">
                            <a-upload list-type="picture-card" :beforeUpload="() => false" :file-list="fileListbanner"
                                @preview="handlePreviews" @change="handleChangess" :remove="getdels" :multiple="true">
                                <div v-if="fileListbanner.length < 8">
                                    <a-icon type="plus" />
                                    <div class="ant-upload-text">点击上传</div>
                                </div>
                            </a-upload>
                            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancels">
                                <img alt="example" style="width: 100%" :src="previewImage" />
                            </a-modal>
                        </div>
                    </a-form-item>

                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <div style="display: flex; align-items: center;">
                            <span> 碎屏保障:</span>
                            <div style="margin-left: 20px;">
                                <a-input type="number" v-model="broken_price" placeholder="请输入碎屏保障" />
                            </div>
                        </div>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <div style="display: flex; align-items: center;">
                            <span> <span style="color:red">*</span> 套餐类型:</span>
                            <div style="margin-left: 20px;">
                                <a-checkbox-group v-model="packageType" @change="handleCheckboxChangezuqi">
                                    <a-checkbox v-for="(item, index) in zuqiList" :key="index" :value="item.id.toString()">
                                        {{ item.title }}
                                    </a-checkbox>
                                </a-checkbox-group>
                            </div>
                        </div>
                    </a-form-item>
                    <!-- 添加规格 -->
                    <a-row v-for="(item, index) in k_ruledata" :key="index"
                        style="width: calc(100% - 20px);margin: 10px 0;display: flex;flex-wrap: wrap;">
                        <span style="margin-right: 10px;padding-top: 5px;">{{ item.k_rule_name }}:</span>
                        <div v-for="(itemto, indexto) in item.k_moreruledata" :key="indexto" class="item-info-box">
                            <div class="txt-item">
                                <div class="left">
                                    {{ itemto.sku }}
                                </div>
                                <!-- <div class="right" @click="deleteBtn(index, indexto, itemto, item.k_rule_name)">
                                    <span class="r-txt">X</span>
                                </div> -->
                                <div class="right" @click="deleteBtn(index, indexto, itemto)" v-if="item.k_rule_name == '颜色' || item.k_rule_name == '内存'">
                                    <span  class="r-txt">X</span>
                                </div>
                            </div>
                        </div>
                        <!-- <a-input placeholder="设置属性" v-model="item.provaluse"
                            style="width: 150px;height: 30px;margin-right: 10px" />
                        <a-button type="primary" @click="k_addpro(item, index)" style="width: 60px;height: 30px">添加
                        </a-button> -->

                        <a-input placeholder="设置属性" v-model="item.provaluse" v-if="item.k_rule_name == '颜色' || item.k_rule_name == '内存'" style="width: 150px;height: 30px;margin-right: 10px" />
                        <div style="margin-top:5px;" v-else-if="item.k_rule_name == '套餐类型'">
                            <span v-if="item.k_moreruledata.length == 0">请选择套餐类型</span>
                        </div>
                        <!-- <a-input placeholder="请勾选租期套餐或租期" v-model="item.provaluse" v-else :disabled="true" style="width: 150px;height: 30px;margin-right: 10px" /> -->
                        <a-button type="primary" v-if="item.k_rule_name == '颜色' || item.k_rule_name == '内存'" @click="k_addpro(item, index)" style="width: 60px;height: 30px">添加
                        </a-button>


                    </a-row>
                    <a-button type="primary" style="margin: 20px 0;width: 600px" @click="autodata">生成</a-button>

                    <div>
                        <a-form layout="inline" :form="form" style="margin-bottom: 15px">
                            <div v-if="autodata_rule" style="overflow-y: scroll;height: 300px;width:1050px;">
                                <a-table :dataSource="autoruledata" :columns="columnsList" :pagination="false"
                                    :row-key="(n, i) => i"></a-table>
                            </div>
                        </a-form>
                    </div>

                    <!-- <a-button type="primary" style="margin-top: 20px;width: 600px" @click="savetable">保存规格</a-button> -->

                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 参数:</span>
                        <div class="diy-item" v-for="(item, index) in parameterArr" :key="index">
                            <a-input placeholder="请输入名称" v-model="item.title" />
                            <div class="diy-center"> - </div>
                            <a-input placeholder="请输入参数" v-model="item.context" />
                            <a-button class="diy-end" type="primary" @click="diybtn('add', index)"> + </a-button>
                            <a-button class="diy-end" type="primary" ::danger='true' @click="diybtn('delete', index)"> -
                            </a-button>
                        </div>
                        <a-button v-if="parameterArr.length == 0" class="diy-end" type="primary" @click="diybtn('add')"> +
                        </a-button>
                    </a-form-item>
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <span> <span style="color:red">*</span> 配件:</span>
                        <a-input v-decorator="[`accessory`, { rules: [{ required: true, message: '请输入配件' }] }]"
                            placeholder="请输入配件" />
                    </a-form-item>
                </a-form>

                <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <span> <span style="color:red">*</span> 产品详情图:</span>
                    <div class="clearfix">
                        <a-upload list-type="picture-card" :beforeUpload="() => false" :file-list="fileListProductContent"
                                  @preview="handlePreviews" @change="handleProductContentChangess" :remove="getProductContentdels" :multiple="true">
                            <div v-if="fileListProductContent.length < 30">
                                <a-icon type="plus" />
                                <div class="ant-upload-text">点击上传</div>
                            </div>
                        </a-upload>
                        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancels">
                            <img alt="example" style="width: 100%" :src="previewImage" />
                        </a-modal>
                    </div>
                </a-form-item>

                <a-button  type="primary" @click="sub">
                    提交
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>

<script>
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}
const EditableCell = {
    template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
    props: {
        text: String
    },
    data() {
        return {
            value: this.text,
            editable: false
        }
    },
    methods: {
        handleChange(e) {
            const value = e.target.value
            this.value = value
        },
        check() {
            this.editable = false
            this.$emit('change', this.value)
        },
        edit() {
            this.editable = true
        }
    }
}
import Home from '../../api/Home'
import Shop from '../../api/Shop'
import GoodsCats from '@/api/GoodsCats'
import Newness from '@/api/Newness'
import Discounts from '@/api/Discounts'

import editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/code'
import 'tinymce/plugins/link'
import '../../../public/tinymce/axupimgs'
import Goods from '@api/Goods'
import specsgoods from "@/components/specsgoods/specsgoods.vue"
import { templateSettings } from 'lodash'
export default {
    name: 'newEdit',
    components: {
        editor,
        EditableCell,
        specsgoods
    },
    data() {
        return {
            shopDetail: '',
            url:'',
            is_open_url:1,
            broken_price: '',
            designlist: [
                {
                    "id": 1,
                    "title": "固定租期（芝麻预授权=总租金（天租金*租期）+押金  允许提前归还）",
                },
                {
                    "id": 2,
                    "title": "租完即送（芝麻预授权=总租金（天租金*租期） 不允许提前归还）",
                },
            ],
            zuqiList:[
                {
                    id:1,
                    title:'租完归还'
                },
                {
                    id:2,
                    title:'租完即送'
                }
            ],
            packageType:[],
            changezuqi:[],
            formone: this.$form.createForm(this),
            dataYi: [],
            dataEr: [],
            previewVisible: false,
            visible: false,
            visible2: false,
            visibleshop: false,
            visibleshoper: false,
            count: 0,
            counter: 0,

            previewImage: '',
            fileList: [],
            fileList1: [],
            fileList2: [],
            fileListbanner: [
                /*{
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
                },*/
            ],
            fileListProductContent: [],
            //45564
            form: this.$form.createForm(this),
            loading: this.$route.query.id ? true : false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 3 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 }
            },
            pic: '',
            id: this.$route.query.id || undefined,
            init: {
                language_url: `https://zuji.ahxunbu.com/tinymce/langs/zh_CN.js`, //语言包的路径
                language: 'zh_CN', //语言
                skin_url: `https://zuji.ahxunbu.com/tinymce/skins/ui/oxide`, //skin路径
                height: 500, //编辑器高度
                branding: false, //是否禁用“Powered by TinyMCE”
                menubar: false, //顶部菜单栏显示
                plugins: 'image axupimgs media',
                // plugins: 'axupimgs media',
                convert_urls: false,
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImgUpload(blobInfo, success, failure)
                },
                toolbar:
                    'axupimgs | undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
            },
            content: '',
            img: '',
            value: '',
            title_img: '',
            second: '',
            searchData: {
                cat_id: undefined,
                shop_id: undefined,
                type: undefined,
                zuday: undefined
            },
            goods_id_list: [], // 相关商品id
            orderStatus: [],
            fenlei: [],
            shop: [],
            addtype: '',
            name: '',
            Yikey: '',
            addkey: '',
            Save: false,
            SaceKey: '',

            rule: false,//规格
            ruledata: [],
            k_ruledata: [
                {
                    k_rule_name: '套餐类型',
                    k_moreruledata: []
                },
                {
                    k_rule_name: '内存',
                    k_moreruledata: []
                },
                {
                    k_rule_name: '颜色',
                    k_moreruledata: []
                },
                // {
                //     k_rule_name: '租期',
                //     k_moreruledata: []
                // },
            ],//一个规格--》对应 多个属性
            autodata_rule: false,
            autoruledata: [], //表格渲染的数据
            zum: [],
            // <a-input v-model={v.is_buyout} Oninput={handleInputChange(v,v.is_buyout)} placeholder="是否买断" />
            // <a-radio-group v-model={v.is_buyout} >
            //     <a-radio value={1}>否</a-radio>
            //     <a-radio value={2}>是</a-radio>
            // </a-radio-group>
            columnsList: [
                {
                    title: '套餐名称',
                    dataIndex: 'sku',
                    width: '10%',
                }, {
                    title: '销售价',
                    width: '15%',
                    customRender: (v) => {
                        return (
                            <a-input v-model={v.selling_price} placeholder="请输入销售价" />
                        )
                    }
                }, {
                    title: '是否买断',
                    width: '15%',
                    customRender: (v) => {
                        let newsku = v.sku;
                            newsku = newsku.split(';');
                            // 在 SKU 的任意段查找租期类型，避免网络类型插入后位置变化导致判断失效
                            let hasZuWangGuiHuan = newsku.some(seg => seg && seg.indexOf('租完归还') !== -1);
                            if(hasZuWangGuiHuan){
                            return (
                                <a-radio-group v-model={v.is_buyout} >
                                    <a-radio value={1}>否</a-radio>
                                    <a-radio value={2}>是</a-radio>
                                </a-radio-group>
                            )
                        }else{
                            return (
                                <a-radio-group v-model={v.is_buyout} >
                                    <a-radio value={1}>否</a-radio>
                                </a-radio-group>
                            )
                        }
                    }
                },
                {
                    title: '租期-月',
                    width: '15%',
                    customRender: (v) => {
                        return (
                            <a-input type={Number} v-model={v.month} placeholder="请输入租期-月" />
                        )
                    }
                },
                {
                    title: '天租金',
                    width: '15%',
                    customRender: (v) => {
                        return (
                            <a-input v-model={v.month_price} placeholder="请输入天租金" />
                        )
                    }
                },
                {
                    title: '押金',
                    width: '15%',
                    customRender: (v) => {
                        return (
                            <a-input v-model={v.deposit} placeholder="请输入押金" />
                        )
                    }
                },
                {
                    title: '库存',
                    width: '15%',
                    customRender: (v) => {
                        return (
                            <a-input v-model={v.stock} placeholder="请输入库存" />
                        )
                    }
                },
                {
                    title: '图片',
                    width: '10%',
                    scopedSlots: { customRender: 'image' },
                    customRender: (v, i) => {
                        if (v.image) {
                            return (
                                <img style="width: 30px;height:30px" onClick={() => { this.deletegoodsImg(v, i) }} src={v.image} />
                            )
                        } else {
                            return (
                                <div class="btnCon">
                                    <input onChange={($event) => this.handleChange($event, 3, v)} type="file" accept="image/*" />
                                    <a-button-group>
                                        <a-button type="primary">选择图片</a-button>
                                    </a-button-group>
                                </div>
                            )
                        }
                    }
                }
            ],
            attribute: [],
            newTableList: [],
            parameterArr: [{
                title: '',
                context: ''
            }],
            copy_data: [], //表格生成的镜像数据，用于删除等操作
            add_data: [], //之后生成规格的数据
            fenlei: [],
            shop: [],
            Shoplist: [],
            goodscatslist: [],
            goodscatlist: [],
            discountslist: [],
            newnesslist: [],
            putawaylist:[
                {id:1,title:'上架'},
                {id:2,title:'下架'}
            ],
            hotlist:[
                {id:1,title:'否'},
                {id:2,title:'是'}
            ],
            k_num: [] //返回的数量
        }
    },
    mounted() {
        this.initsss()
        if (this.id) {
            this.getOne()
        }
    },
    methods: {
        handleCheckboxChangezuqi(id){
            this.changezuqi = id
        },
        handleImgUpload(blobInfo, success, failure) {
            let file = blobInfo.file
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    console.log(res.result)
                    this.content += `<img src=${res.result} style="width:100%;height:100%"/>`
                    success('')
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },
        handleCancels() {
            this.previewVisible = false
        },
        async handlePreviews(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj)
            }
            this.previewImage = file.url || file.preview
            this.previewVisible = true
        },
        getSave(data) {
            this.visible = true
            this.Save = true
            this.SaceKey = data.key

            this.$nextTick(() => {
                this.formone.setFieldsValue({
                    name: data.name
                })
            })
        },
        getSave2(data) {
            this.visible2 = true
            this.Save = true
            this.SaceKey = data.key

            this.$nextTick(() => {
                this.formone.setFieldsValue({
                    name: data.name,
                    price: data.price
                })
            })
        },
        getDel(data) {
            this.dataEr.some((item, i) => {
                if (item.key == data.key) {
                    this.dataEr.splice(i, 1)
                    /// some循环如果true,就会终止后续循环
                    return true
                }
            })
        },
        getDelOne(data) {
            this.dataYi.some((item, i) => {
                if (item.key == data.key) {
                    this.dataYi.splice(i, 1)
                    this.name = ''
                    /// some循环如果true,就会终止后续循环
                    return true
                }
            })
        },
        getdels(Promise) {
            for (let i = 0; i < this.fileListbanner.length; i++) {
                if (Promise.uid == this.fileListbanner[i].uid) {
                    this.fileListbanner.splice(i, 1)
                }
            }
        },
        getProductContentdels(Promise) {
            for (let i = 0; i < this.fileListProductContent.length; i++) {
                if (Promise.uid == this.fileListProductContent[i].uid) {
                    this.fileListProductContent.splice(i, 1)
                }
            }
        },
        handleChangess(e, type) {
            let file = e.file
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    // this.pic = res.data.url
                    if (this.fileListbanner.length > 0) {
                        let arr = []
                        for (let i = 0; i < this.fileListbanner.length; i++) {
                            arr.push(this.fileListbanner[i].uid)
                        }
                        let minInNumbers = Math.min.apply(Math, arr)
                        this.fileListbanner.push({
                            url: res.result,
                            uid: minInNumbers - 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    } else {
                        this.fileListbanner.push({
                            url: res.result,
                            uid: this.fileListbanner.length + 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    }
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },

        handleProductContentChangess(e, type) {
            let file = e.file
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    // this.pic = res.data.url
                    if (this.fileListProductContent.length > 0) {
                        let arr = []
                        for (let i = 0; i < this.fileListProductContent.length; i++) {
                            arr.push(this.fileListProductContent[i].uid)
                        }
                        let minInNumbers = Math.min.apply(Math, arr)
                        this.fileListProductContent.push({
                            url: res.result,
                            uid: minInNumbers - 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    } else {
                        this.fileListProductContent.push({
                            url: res.result,
                            uid: this.fileListProductContent.length + 1,
                            name: 'image.png',
                            status: 'done'
                        })
                    }
                })
                reader.onload = null
            }
            reader.readAsDataURL(file)
        },

        initsss() {
            Goods.Cats().then(res => {
                this.fenlei = res.result
                this.fenlei.forEach(item => {
                    if (item.level > 1) {
                        for (let i = 1; i < item.level; i++) {
                            item.name = '---' + item.name
                        }
                        item.name = '|' + item.name;
                    }
                })
                // this.fenlei = [];
                // res.result.forEach(item=>{
                //     if(item.level == 3){
                //         this.fenlei.push(item)
                //     }
                // })
            })
            Shop.ShopList().then(res => {
                this.Shoplist = res.result;
            })
            GoodsCats.GoodsCatsList().then(res => {
                this.goodscatslist = res.result
            })
            Goods.GoodsCatList().then(res => {
                this.goodscatlist = res.result
                this.goodscatlist.forEach(item => {
                    if (item.level > 1) {
                        for (let i = 1; i < item.level; i++) {
                            item.name = '---' + item.name
                        }
                        item.name = '|' + item.name;
                    }
                })
            })
            Newness.NewnessList().then(res => {
                this.newnesslist = res.result
            })
            Discounts.DiscountsList().then(res => {
                this.discountslist = res.result
            })
        },

        diybtn(type, index) {
            if (type == 'add') {
                // if(!this.parameterArr[index].title || !this.parameterArr[index].context){
                //     this.$message.warning('请先填写');
                //     return false
                // }
                this.parameterArr.push({ title: '', context: '' })
            } else {
                this.parameterArr.splice(index, 1)
            }
            this.$forceUpdate();
        },
        handleChange(e, type, obj, index) {
            let file = e.target.files[0]
            let reader = new FileReader()
            reader.onload = () => {
                if (type === 3) {
                    console.log('this.autoruledata', this.autoruledata)
                    this.autoruledata.forEach((item, i) => {
                        if (item.sku.indexOf(obj.sku) != -1) {
                            console.log('this.autoruledata.forEach', item)
                            Home.upload({ img: reader.result }).then(res => {
                                if (res.status == 1) {
                                    this.autoruledata[i]['image'] = res.result;
                                    return
                                }
                            })
                        }
                    })
                } else {
                    Home.upload({ img: reader.result }).then(res => {
                        if (type === 1) {
                            this.title_img = res.result
                        } else if (type === 2) {
                            this.img = res.result
                        } else if (type === 3) {

                            console.log(this.autoruledata)
                            console.log(obj)
                            // this.autoruledata[obj.index].image = res.result   初始写法
                        } else {
                            this.content += `<img src=${res.result} style="width:100%;height:100%"/>`
                        }
                    })
                }

                reader.onload = null
            }
            reader.readAsDataURL(file)
        },


        deletegoodsImg(v, i) {
            v.image = '';
        },
        async handleChangesstable(e, index) {
            let files = await getBase64(e.file.originFileObj)
            this.autoruledata.forEach((item, i) => {
                if (item.sku.indexOf(index.sku) != -1) {
                    console.log('this.autoruledata.forEach', item)
                    Home.upload({ img: files }).then(res => {
                        if (res.status == 1) {
                            this.autoruledata[i]['image'] = res.result;
                            return
                        }
                    })
                }
            })
        },
        // deleteBtn(v, i, item, name) {
        //     this.k_ruledata[v].k_moreruledata.splice(i, 1);
        //     try {
        //         let arr = this.k_num.filter(n => {
        //             return n.name == name
        //         })
        //         if (arr.length != 0) throw '不需要执行'
        //     } catch (err) {
        //         this.copy_data = this.de_data(this.copy_data, item.sku)
        //     }
        // },
        deleteBtn(v, i, item) {
            this.k_ruledata[v].k_moreruledata.splice(i, 1);
            if (this.copy_data && this.copy_data.length) {
                for (let n = 0; n < this.copy_data.length; n++) {
                    if (this.copy_data[n].sku.indexOf(item.sku) != -1) {
                        this.copy_data.splice(n, 1)
                        n--
                    }
                }
            }
        },
        de_data(arr, sku) {
            try {
                arr.forEach((item, index) => {
                    if (item.sku.indexOf(sku) != -1) {
                        arr.splice(index, 1)
                        throw arr
                    }
                })
            } catch (data) {
                this.de_data(data, sku);
                return data
            }
        },
        k_addpro(item, index) {//添加属性
            if (item.provaluse == '' || item.provaluse == undefined) {
                this.$message.info('请勿填空')
                return
            }
            let ss = { id: '', sku: item.provaluse };
            item.k_moreruledata.push(ss);
            item.k_rule = true;
            //添加完成后
            item.provaluse = "";
        },
        autodata() {//自动生成

            if(!this.changezuqi || this.changezuqi.length === 0){
                this.$message.info('请先选择套餐类型');
                return;
            }
            for (let i = 0; i < this.k_ruledata.length; i++) {
                if (this.k_ruledata[i].k_rule_name === "内存" && this.k_ruledata[i].k_moreruledata.length === 0) {
                    this.$message.info('请填写内存');
                    return; // 提前结束函数执行，阻止代码继续执行
                }
                if (this.k_ruledata[i].k_rule_name === "颜色" && this.k_ruledata[i].k_moreruledata.length === 0) {
                    this.$message.info('请填写颜色');
                    return; // 提前结束函数执行，阻止代码继续执行
                }
            }
            // 套餐类型 -> 把选择的租期套餐映射到对应的规则项（按名称匹配）
            let newstr = [] //获取套餐类型
            this.changezuqi.forEach((i)=>{
                this.zuqiList.forEach((v)=>{
                    if(i == v.id){
                        newstr.push(v.title)
                    }
                })
            })
            if(newstr.length > 0){
                let newzuqilist = []
                newstr.forEach(v=>{
                    newzuqilist.push({ sku: v })
                })
                // 找到 k_rule_name 为 '套餐类型' 的规则并赋值
                let idx = this.k_ruledata.findIndex(r => r.k_rule_name === '套餐类型')
                if (idx !== -1) {
                    this.k_ruledata[idx].k_moreruledata = newzuqilist
                } else {
                    // 如果未找到则在开头插入，保证后续生成逻辑可用
                    this.k_ruledata.unshift({ k_rule_name: '套餐类型', k_moreruledata: newzuqilist })
                }
                    // 在套餐类型后面确保存在一个网络类型规则，始终包含 全网通
                    let netIdx = this.k_ruledata.findIndex(r => r.k_rule_name === '网络类型')
                    const netRule = { k_rule_name: '网络类型', k_moreruledata: [{ sku: '全网通' }] }
                    if (idx !== -1) {
                        if (netIdx === -1) {
                            // 插入到套餐类型后面
                            this.k_ruledata.splice(idx + 1, 0, netRule)
                        } else {
                            // 更新已有的网络类型为全网通
                            this.k_ruledata[netIdx].k_moreruledata = [{ sku: '全网通' }]
                        }
                    } else {
                        // 如果套餐类型是新插入在开头的情况，确保网络类型紧随其后
                        if (this.k_ruledata[1] && this.k_ruledata[1].k_rule_name !== '网络类型') {
                            this.k_ruledata.splice(1, 0, netRule)
                        }
                    }
            }
            this.zum = [];
            for (let index in this.k_ruledata) {//循环的次数
                this.getDate(this.zum, this.k_ruledata[index]);
            }

            for (let index in this.zum) {
                this.zum[index].id = 0;
                this.zum[index].selling_price = '';//销售价
                this.zum[index].month = '';//租期
                this.zum[index].month_price = '';//月租金
                this.zum[index].deposit = '';//押金
                this.zum[index].stock = '';//库存
                this.zum[index].image = '';//图片
                this.zum[index].is_buyout = '';//是否买断
            }

            this.autoruledata = JSON.parse(JSON.stringify(this.zum))


            // let arr1 = [], arr2 = [];
            // this.newTableList.forEach(item => {
            //     this.zum.forEach((v, i) => {
            //         if ((v.sku.indexOf(item.sku) != -1 || item.sku.indexOf(v.sku) != -1) && arr2.indexOf(v.sku) == -1) {
            //             arr1.push(i);
            //             arr2.push(item.sku)
            //         }
            //     })
            // })

            //this.newTableList 后台反回的数据
            //this.autoruledata 前端渲染生成的表格

            // this.autoruledata = JSON.parse(JSON.stringify(this.zum))
            // if (this.copy_data) {
            //     try {
            //         let num = 0;//记录有数据列表
            //         this.k_ruledata.forEach((item, index) => {
            //             if (item.k_moreruledata.length) num++
            //         })
            //         if (num != this.k_num.length) throw '不需要执行'
            //         this.k_ruledata.forEach(item => {
            //             this.k_num.forEach(v => {
            //                 if (item.k_rule_name.indexOf(v.name) != -1 && !item.k_moreruledata.length) throw '不需要执行'
            //             })
            //         })

            //         this.autoruledata.forEach((item, index) => {
            //             this.copy_data.forEach(v => {
            //                 if (item.sku.indexOf(v.sku) != -1) {
            //                     this.autoruledata.splice(index, 1, {
            //                         ...v, index
            //                     })
            //                 } this.autoruledata[index].index = index
            //             })
            //         })

            //     } catch (err) {
            //         console.log("数据增加不需要执行")
            //     }

            // }
            // this.$forceUpdate();
            // this.autodata_rule = true;

            if (this.copy_data) {
                this.autoruledata.forEach((item, index) => {
                    this.copy_data.forEach(v => {
                        if (item.sku.indexOf(v.sku) != -1) {
                            this.autoruledata.splice(index, 1, {
                                ...v, index
                            })
                        } this.autoruledata[index].index = index
                    })
                })
            } else {
                this.autoruledata = JSON.parse(JSON.stringify(this.zum))
            }
            this.$forceUpdate();
            this.autodata_rule = true;
        },
        getDate(zum, first) {//公共存的集合  第一个集合
            if (zum.length != 0) {
                let item = first.k_moreruledata;
                let zumto = [];
                for (let index in zum) {
                    for (let to in item) {
                        let ss = {};
                        // ss.sku = zum[index].sku + "/" + first.k_rule_name + ":" + item[to].sku;
                        ss.sku = zum[index].sku + ";" + item[to].sku;
                        zumto.push(ss);
                    }
                }
                this.zum = zumto;
            } else {
                let item = first.k_moreruledata;
                for (let index in item) {
                    let ss = {};
                    ss.sku = item[index].sku;
                    // ss.sku = first.k_rule_name + ":" + item[index].sku;
                    zum.push(ss);
                }
                this.zum = zum;

            }
        },
        savetable() {
            let arr = [];
            // this.k_ruledata.forEach(i => {
            //     let item = [];
            //     i.k_moreruledata.forEach((n) => {
            //         item.push(n.sku)
            //     })
            //     arr.push({
            //         name: i.k_rule_name, item
            //     })
            // })
            // this.attribute = arr;
            // this.$message.success('保存规格成功')

            this.k_ruledata.forEach(i => {
                let item = [];
                // if (!i.k_rule_name) {
                //     i.k_rule_name = '';

                // }
                i.k_moreruledata.forEach((n) => {
                    item.push(n.sku)
                })
                arr.push({
                    name: i.k_rule_name, item
                })
            })

            this.attribute = arr;
            // console.log('保存的规格数据k_ruledata：', this.k_ruledata)
            // console.log('保存的规格数据：', this.attribute)
            // console.log('保存的表格数据：', this.autoruledata)
        },
        // 编辑
        getOne() {
            Goods.FindGoods({ id: this.id }).then(res => {
                this.loading = false
                this.$nextTick(() => {
                    this.url = res.reuslt.url;
                    this.is_open_url = res.reuslt.is_open_url;

                    this.img = res.reuslt.img;
                    this.content = res.reuslt.content;
                    this.content_en = res.reuslt.content_en;
                    this.content_es = res.reuslt.content_es;
                    this.searchData.cat_id = res.reuslt.cat_id;
                    this.searchData.is_open_Id = res.reuslt.is_open_id;
                    this.searchData.goods_cat_id = res.reuslt.goods_cat_id;
                    this.searchData.type = res.reuslt.type;
                    this.searchData.shop_id = res.reuslt.shop_id;
                    this.searchData.goods_cats_id = res.reuslt.goods_cats_id;
                    this.searchData.discounts_id = res.reuslt.discounts_id;
                    this.broken_price = res.reuslt.broken_price;
                    this.shopDetail = res.reuslt.cont;
                    this.changezuqi = res.reuslt.design//定义
                    this.packageType = res.reuslt.design//赋值
                    this.searchData.putaway = res.reuslt.putaway
                    this.searchData.hot = res.reuslt.hot
                    if (res.reuslt.parameter) this.parameterArr = JSON.parse(res.reuslt.parameter)
                    this.form.setFieldsValue({
                        price: res.reuslt.price,
                        name: res.reuslt.name,
                        day: res.reuslt.day,
                        small_day: res.reuslt.small_day,
                        accessory: res.reuslt.accessory,
                        sort: res.reuslt.sort,
                        goods_num: res.reuslt.goods_num,
                        dit: res.reuslt.dit,
                        fan_price: res.reuslt.fan_price,
                        dan_price: res.reuslt.dan_price,
                        zong_price: res.reuslt.zong_price,
                        zuday: res.reuslt.zuday,
                        type: res.reuslt.type,
                        ya_type: res.reuslt.ya_type,
                        dai_type: res.reuslt.dai_type,
                        jian_price: res.reuslt.jian_price,
                        jia_nper: res.reuslt.jia_nper,
                        deposit: res.reuslt.deposit,
                        design: res.reuslt.design,
                        cat_id: res.reuslt.cat_id,
                        goods_cat_id: res.reuslt.goods_cat_id,
                        goods_cats_id: res.reuslt.goods_cats_id,
                        discounts_id: res.reuslt.discounts_id,
                        putaway: res.reuslt.putaway,
                        hot: res.reuslt.hot,
                        shop_id: res.reuslt.shop_id,
                        newness_id: res.reuslt.newness_id,
                        url:res.reuslt.url,
                        is_open_url:res.reuslt.is_open_url,
                    })
                    if (res.reuslt.photo) {
                        let imageArr = res.reuslt.photo.split(',')
                        if (imageArr.length > 0) {
                            for (let i = 0; i < imageArr.length; i++) {
                                this.fileListbanner.push({
                                    url: imageArr[i],
                                    uid: i,
                                    name: 'image.png',
                                    status: 'done'
                                })
                            }
                        }
                    }
                    if (res.reuslt.product_content) {
                        let imageArr = res.reuslt.product_content.split(',')
                        if (imageArr.length > 0) {
                            for (let i = 0; i < imageArr.length; i++) {
                                this.fileListProductContent.push({
                                    url: imageArr[i],
                                    uid: i,
                                    name: 'image.png',
                                    status: 'done'
                                })
                            }
                        }
                    }

                    if (res.reuslt.sku && res.reuslt.attribute) {
                        //表格数据
                        res.reuslt.sku = res.reuslt.sku.map((v, i) => {
                            return {
                                index: i, ...v
                            }
                        })
                        this.copy_data = JSON.parse(JSON.stringify(res.reuslt.sku)); //表格的数据
                        this.autoruledata = JSON.parse(JSON.stringify(res.reuslt.sku))
                        this.autodata_rule = true;
                        console.log("初始化表格数据", this.autoruledata)

                        this.rule = true;
                        this.k_num = res.reuslt.attribute
                        res.reuslt.attribute.forEach((item) => {
                            this.k_ruledata.forEach((i, k) => {
                                if (i.k_rule_name == item.name) {
                                    item.item.forEach(a => {
                                        i.k_moreruledata.push({ sku: a })
                                    })
                                }
                            })
                        })

                        this.url         = res.reuslt.url;
                        this.is_open_url = res.reuslt.is_open_url;

                        // this.rule = true;
                        // res.reuslt.attribute.forEach((item) => {
                        //     this.k_ruledata.forEach((i, k) => {
                        //         if (i.k_rule_name == item.name) {
                        //             item.item.forEach(a => {
                        //                 i.k_moreruledata.push({ sku: a })
                        //             })
                        //         }
                        //     })
                        // })

                    }
                })
            })
        },
        sub() {
            let arr = []
            let productContentArr = []
            for (let i = 0; i < this.fileListbanner.length; i++) {
                arr.push(this.fileListbanner[i].url)
            }
            for (let i = 0; i < this.fileListProductContent.length; i++) {
                productContentArr.push(this.fileListProductContent[i].url)
            }
            // if(this.broken_price == ''){
            //     this.$message.warning('请填写碎屏保障');
            //     return
            // }
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;
                    try {
                        this.parameterArr.forEach(item => {
                            if (!item.title || !item.context) throw '请输入参数'
                        })
                    } catch (err) {
                        this.$message.warning(err);
                    }
                    values.parameter = this.parameterArr
                    this.savetable();
                    Goods[this.id ? `SaveGoods` : `AddGoods`]({
                        ...values,
                        photo: arr.join(','),
                        product_content: productContentArr.join(','),
                        img: this.img,
                        id: this.id,
                        content: this.content,
                        sku: JSON.stringify(this.autoruledata),
                        attribute: JSON.stringify(this.attribute),
                        broken_price: this.broken_price ? this.broken_price : '0',//碎屏保障
                        cont: this.shopDetail,  //详情
                        url:this.url,
                        is_open_url:this.is_open_url,
                        design:this.packageType,//1固定租期 2租完即送
                        // design:this.changezuqi,
                    }).then(res => {
                            this.loading = false
                            this.$router.back()
                        })
                        .catch(res => {
                            this.loading = false
                        })
                }
            })
        },
        handleRadioChange(key, value) {
            // 处理单选框变化事件
            console.log('行 key:', key, '选择值:', value);
        }
    }
}
</script>

<style scoped lang="less">
.input-border {
    padding: 30px;
    margin: 20px;
    border: 1px solid #000;
    border-radius: 10px;

}

.input-margin {
    display: flex;
    align-items: center;
    margin: 20px 0;
}

.input-width {
    width: 60%;
}

.span-bottom {
    margin-bottom: 10px;
}

.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }

        video {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }
    }
}

.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.editCon {
    margin-bottom: 20px;
    position: relative;
    border: 1px solid #fff;

    .editCon {
        position: absolute;
        z-index: 1;
        top: 3px;
        right: 5px;
    }
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}
</style>
<style>
.tox-tinymce-aux {
    z-index: 9999999 !important;
}

.tox-menu {
    z-index: 9999999 !important;
    top: 780px !important;
    max-height: 1000px !important;
}

.tox-collection__group {
    z-index: 9999999 !important;
}

.diy-item {
    display: flex;
    align-items: center;
}

.diy-end {
    margin-left: 10px;
}

.diy-center {
    margin: 0 10px;
}

.addimg {
    width: 80px;
    height: 80px;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, .2);
    text-align: center;
    line-height: 80px;
}

.h-item-box {

    display: flex;
    flex-wrap: wrap;
}

.item-info-box {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
}

.txt-item {
    height: 32px;
    border-radius: 4px;
    border: 1px solid #1890ff;
    font-size: 14px;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 14px 14px 0;
}

.left {
    text-align: center;
    height: 32px;
    line-height: 32px;
    color: #1890ff;
    padding: 0 8px;
}

.right {
    text-align: center;
    color: #1890ff;
    padding: 5px 8px 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    border-left: 1px solid #1890ff;

}

.r-txt {
    text-align: center;
    color: #1890ff;
    font-size: 15px;
    cursor: pointer;
}

</style>
